import { getDiscount } from '../../../utils/functions';
import StarIcon from '@mui/icons-material/Star';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addToWishlist, removeFromWishlist } from '../../../actions/wishlistAction';
import { addItemsToCart, removeItemsFromCart } from '../../../actions/cartAction';
import { useSnackbar } from 'notistack';
import { useLang, uiText } from '../../../utils/i18n';

const Product = (props) => {

    const { _id, name, nameZh, images, ratings, numOfReviews, price, cuttedPrice, outOfStock } = props;

    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const { lang } = useLang();
    const displayName = lang === 'zh' && nameZh ? nameZh : name;

    const { wishlistItems } = useSelector((state) => state.wishlist);
    const { cartItems } = useSelector((state) => state.cart);

    const itemInWishlist = wishlistItems.some((i) => i.product === _id);
    const cartItem = cartItems.find((i) => i.product === _id);

    const addToWishlistHandler = () => {
        if (itemInWishlist) {
            dispatch(removeFromWishlist(_id));
            enqueueSnackbar(uiText('removeFromWishlist', lang), { variant: "success" });
        } else {
            dispatch(addToWishlist(_id));
            enqueueSnackbar(uiText('addedToWishlist', lang), { variant: "success" });
        }
    }

    const addToCartHandler = () => {
        dispatch(addItemsToCart(_id, 1));
        enqueueSnackbar(uiText('addedToCart', lang), { variant: "success" });
    }

    const increaseQty = () => {
        // No stock cap anymore — inventory counts aren't tracked, so
        // customers can order as much as they like.
        dispatch(addItemsToCart(_id, cartItem.quantity + 1));
    }

    const decreaseQty = () => {
        if (cartItem.quantity <= 1) {
            dispatch(removeItemsFromCart(_id));
            return;
        }
        dispatch(addItemsToCart(_id, cartItem.quantity - 1));
    }

    const discount = getDiscount(price, cuttedPrice);

    return (
        <div className="px-1 py-2 sm:px-2 sm:py-3">
            <div className="border-0 rounded-lg hover:shadow-lg transition-shadow shadow-sm bg-white p-3 sm:p-5 flex flex-col gap-2 relative h-full">

                {discount > 0 &&
                    <span className="absolute top-3 left-3 bg-primary-blue text-white text-xs font-medium px-2 py-0.5 rounded-sm z-[1]">
                        {discount}%
                    </span>
                }

                <span onClick={addToWishlistHandler} className={`${itemInWishlist ? "text-red-500" : "text-gray-300 hover:text-red-500"} absolute top-3 right-3 cursor-pointer z-[1]`}>
                    <FavoriteBorderIcon sx={{ fontSize: "20px" }} />
                </span>

                <Link to={`/product/${_id}`} className="flex flex-col items-center text-center group">
                    <div className="w-24 h-24 sm:w-32 sm:h-32 my-2">
                        <img draggable="false" className="w-full h-full object-contain" src={images && images.length > 0 ? images[0].url : "https://placehold.co/300x300?text=No+Image"} alt={displayName} />
                    </div>
                    <h2 className="text-xs sm:text-sm text-gray-800 group-hover:text-primary-blue text-left w-full h-9 sm:h-10 overflow-hidden">{displayName.length > 50 ? `${displayName.substring(0, 50)}...` : displayName}</h2>
                </Link>

                <span className={`text-xs font-medium ${!outOfStock ? "text-primary-green" : "text-red-500"}`}>
                    {!outOfStock ? uiText('inStock', lang) : uiText('outOfStockCaps', lang)}
                </span>

                <span className="text-xs text-gray-500 flex gap-1 items-center">
                    <StarIcon sx={{ fontSize: "14px" }} className="text-yellow-500" />
                    {ratings.toFixed(1)} ({numOfReviews.toLocaleString()})
                </span>

                <div className="flex items-center gap-2 text-sm">
                    {cuttedPrice > price && <span className="text-gray-400 line-through">HK${cuttedPrice.toLocaleString()}</span>}
                    <span className="font-semibold text-red-500">HK${price.toLocaleString()}</span>
                </div>

                {outOfStock ? (
                    <button disabled className="mt-1 w-full py-1.5 sm:py-2 text-xs sm:text-sm font-medium rounded-full border border-gray-300 text-gray-400 cursor-not-allowed">
                        {uiText('outOfStockBtn', lang)}
                    </button>
                ) : cartItem ? (
                    <div className="flex items-center justify-between mt-1 border border-primary-blue rounded-full w-full overflow-hidden">
                        <button onClick={decreaseQty} className="flex-1 py-1.5 sm:py-2 text-primary-blue hover:bg-blue-50 flex justify-center"><RemoveIcon sx={{ fontSize: "16px" }} /></button>
                        <span className="text-sm font-medium">{cartItem.quantity}</span>
                        <button onClick={increaseQty} className="flex-1 py-1.5 sm:py-2 text-primary-blue hover:bg-blue-50 flex justify-center"><AddIcon sx={{ fontSize: "16px" }} /></button>
                    </div>
                ) : (
                    <button
                        onClick={addToCartHandler}
                        className="mt-1 w-full py-1.5 sm:py-2 text-xs sm:text-sm font-medium rounded-full border border-primary-blue text-primary-blue hover:bg-primary-blue hover:text-white"
                    >
                        {uiText('addToCartLower', lang)}
                    </button>
                )}

            </div>
        </div>
    );
};

export default Product;